<template>
  <article id="settings__close-account">
    <header class="settings__header">
      <h1 class="heading">
        {{ $t("settings.CLOSE_ACCOUNT") }}
      </h1>
    </header>
    <section class="settings__content">
      <InfoBox
        :content="$t('settings.CLOSE_ACCOUNT_INFO')"
        :is-warning="true"
      />
      <div class="input">
        <input
          id="chk__close_account"
          class="critical"
          type="checkbox"
          name="chk__close_account"
          v-model="accepted"
        >
        <label
          class="label__options"
          for="chk__close_account"
        >{{
          $t("settings.CLOSE_ACCOUNT_ACCEPT")
        }}</label>
      </div>
      <section class="form__controls">
        <SpinnerButton
          :is-disabled="!accepted"
          :button-id="'btn__close_account'"
          :button-class="'btn__warning'"
          :button-type="'submit'"
          :button-listener="openModal"
          :button-text="$t('buttons.CLOSE_ACCOUNT')"
        />
      </section>
      <modal
        v-if="closingAccount"
        @close="closeModal"
        :heading="'headings.CLOSE_ACCCOUNT_MODAL'"
        :subject="'settings.CLOSE_ACCOUNT_MODAL_TEXT'"
        :warning="true"
      >
        <template v-slot:modal-buttons>
          <SpinnerButton
            :button-id="'btn__close_account'"
            :button-class="'btn__warning'"
            :button-type="'submit'"
            :button-listener="onClickCloseAccount"
            :button-text="$t('buttons.CLOSE_ACCOUNT')"
          />
        </template>
      </modal>
    </section>
  </article>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SpinnerButton from "../global/SpinnerButton";
import InfoBox from "../global/InfoBox";
import Modal from "../global/Modal";

export default {
  name: "CloseAccount",
  components: {
    SpinnerButton,
    InfoBox,
    Modal,
  },
  data() {
    return {
      accepted: false,
      closingAccount: false,
    };
  },
  computed: {
    ...mapGetters(["myProfile"]),
  },
  methods: {
    ...mapActions(["closeAccount"]),
    onClickCloseAccount() {
      this.closeAccount().finally(() => (this.closingAccount = false));
    },
    closeModal() {
      this.closingAccount = false;
    },
    openModal() {
      this.closingAccount = true;
    },
  },
};
</script>
